// Reproduce loading with mocka data
// usage:
// await sleep(2000);

const sleep = (msec: number) => {
  return new Promise<void>(function (resolve) {
    setTimeout(function () {
      resolve();
    }, msec);
  });
};

export default sleep;
